'use client'

import { api, setAccessToken } from './api'
import { useAuthStore } from './stores/auth.store'
import type { AuthUser } from './stores/auth.store'

export async function login(email: string, password: string): Promise<AuthUser> {
  const data = await api.post<{ accessToken: string; user: AuthUser }>(
    '/auth/login',
    { email, password },
    { skipAuth: true },
  )

  setAccessToken(data.accessToken)
  useAuthStore.getState().setUser(data.user)
  return data.user
}

export async function logout(): Promise<void> {
  try {
    await api.post('/auth/logout')
  } catch {
    // ignore errors — always clear local state
  }
  setAccessToken(null)
  useAuthStore.getState().clearUser()
}

export async function refreshAccessToken(): Promise<boolean> {
  try {
    const data = await api.post<{ accessToken: string }>(
      '/auth/refresh',
      undefined,
      { skipAuth: true },
    )
    setAccessToken(data.accessToken)
    return true
  } catch {
    setAccessToken(null)
    useAuthStore.getState().clearUser()
    return false
  }
}

/**
 * Called on app boot — silently refreshes the access token using the httpOnly cookie.
 * Populates the auth store if successful.
 */
export async function initAuth(): Promise<void> {
  useAuthStore.getState().setLoading(true)
  try {
    const refreshed = await refreshAccessToken()
    if (refreshed) {
      const data = await api.get<{ user: AuthUser }>('/auth/me')
      useAuthStore.getState().setUser(data.user)
    } else {
      useAuthStore.getState().clearUser()
    }
  } catch {
    useAuthStore.getState().clearUser()
  }
}
